import React from 'react';
const Testimonial = ({
  text,
  name,
  verified
}) => <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-129">
    <p className="text-lg mb-4" data-id="element-130">"{text}"</p>
    <div className="flex items-center" data-id="element-131">
      <p className="font-bold" data-id="element-132">- {name}</p>
      {verified && <div className="flex items-center ml-2 text-green-600 text-sm" data-id="element-133">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-134">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-135" />
          </svg>
          <span data-id="element-136">Verified Customer</span>
        </div>}
    </div>
  </div>;
export const TestimonialSection = () => {
  const testimonials = [{
    text: 'This chain is exactly what I needed. The quality is insane for the price, and people notice it every time I go out.',
    name: 'Marcus',
    verified: true
  }, {
    text: "I bought the pendant for my boyfriend and he hasn't taken it off since. The craftsmanship is top-tier.",
    name: 'Jessica',
    verified: true
  }, {
    text: "Been looking for jewelry that doesn't break the bank but still looks premium. FRZN delivered exactly that.",
    name: 'Chris',
    verified: true
  }, {
    text: 'The bracelet feels heavy and substantial. Definitely not like the cheap stuff you find elsewhere.',
    name: 'Tyler',
    verified: true
  }];
  return <div className="w-full bg-white py-12 px-4 md:px-8" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-139">
          Loved by Thousands
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-140">
          {testimonials.map((testimonial, index) => <Testimonial key={index} {...testimonial} data-id="element-141" />)}
        </div>
      </div>
    </div>;
};